import { useWatchedShows } from '../hooks/useShows'
import { ShowCard } from '../components/ShowCard'
import { route } from 'preact-router'
import { AuthGuard } from '../components/AuthGuard'
import { PageHeader } from '../components/PageHeader'
import { LoadingState } from '../components/LoadingState'

export function RecentShows() {
  const { data: watchedShows, isLoading } = useWatchedShows()

  if (isLoading) {
    return <LoadingState message="Loading shows..." />
  }

  return (
    <AuthGuard>
      <div className="min-h-screen bg-slate-900">
        <PageHeader
          title="Recent Shows"
          showLogout={true}
          navigationTo="/shows/all"
          navigationLabel="All Shows"
        />

        <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
          {watchedShows.length === 0 ? (
            <div className="text-center py-12">
              <p className="text-slate-400 text-lg">No episodes watched yet</p>
              <p className="text-slate-500 mt-2">Start watching episodes to see them here</p>
              <button
                onClick={() => route('/shows/all')}
                className="mt-4 px-6 py-3 bg-slate-700 hover:bg-slate-600 text-white font-medium rounded-md transition-colors"
              >
                View All Shows
              </button>
            </div>
          ) : (
            <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 gap-4">
              {watchedShows.map(
                item =>
                  item && (
                    <ShowCard key={item.show.id} show={item.show} lastWatched={item.lastWatched} />
                  ),
              )}
            </div>
          )}
        </main>
      </div>
    </AuthGuard>
  )
}
